module.exports = __webpack_public_path__ + "img/ms_my.eaf33dff.png";